function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import sendRequest from '../utils/sendRequest';
/**
 * HTTP Request wrapper
 *
 * @param  {Object} state - app state
 * @param  {Object} [headers={}] - request headers
 * @param  {Function} [errorsHandler] - custom handler for WebAPI errors
 * @return {Function} - request function
 */

export default function httpRequest(state) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var errorsHandler = arguments.length > 2 ? arguments[2] : undefined;

  /**
   * HTTP request
   *
   * @param {String} path - API path
   * @param {String} method - HTTP method
   * @param {Object} [body = null] - request body
   * @param {Object} [customHeaders={}] - request headers
   * @param {Object} params – params, like custom parser
   * @return {Promise} - promise
   */
  return function (path, method) {
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var customHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      parser = _ref.parser;
    return sendRequest({
      state: state,
      path: path,
      method: method,
      headers: _objectSpread({}, headers, customHeaders),
      body: body,
      redirect: false,
      parser: parser,
      errorsHandler: errorsHandler
    });
  };
}